<template>
  <section class="section--comp">
    <div class="container items-center">
      <h3 class="section--h3 text-4xl">Customize</h3>
      <p class="section--p mb-10rem text-xl">Customise and continuously improve the learner experience. The new scarcity in the internet age is attention. Since there is a surplus of information, more information flowing through our society than any of us could ever hope to process or understand, the new bottleneck on our economy is attention.</p>
      <h3 class="section--h3 text-4xl lg:text-left lg:w-4/5">Most common reasons for not committing to training</h3>
      <p class="section--p items-left mb-base text-xl">The average worker spends <b>25%</b> of their time on emails and checks their phone <b>150 times a day</b> (Deloitte). And, on top of that, we are interrupted around <b>56 times a day</b> (Atlassian). Staying committed to learning is challenging!</p>
      <p class="section--p items-left text-xl">Meanwhile, the average time people have put aside to learn for work, is around <b>20 mins a week</b> (Bersin & Forbes). A mere 1%. It’s no wonder people are begging for personally customized and timely learning content.</p>
      <vs-card class="lg:w-4/5">
        <vs-row vs-type="flex" vs-justify="space-around">
          <vs-col class="items-left" vs-w="5" vs-sm="12">
            <div class="tips-heading mt-3 mb-base">No time to learn</div>
            <ul class="tips-list">
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Knowing why we’re learning something.</li>
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Learning from real experience.</li>
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Having a say in what and how we learn.</li>
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Focusing on relevant knowledge and skills.</li>
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Solving challenges.</li>
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Being able to motivate ourselves.</li>
            </ul>
          </vs-col>
          <vs-col class="items-left" vs-w="5" vs-sm="12">
            <div class="tips-heading mt-3 mb-base">Cannot discipline to a routine learning </div>
            <ul class="tips-list">
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Attention economy competes for mindshare.</li>
              <li><vs-icon class="mr-3" color="#dc0032" icon="icon-check-circle" icon-pack="feather"/>Learning Digitally comes with digital distractions.</li>
              <div class="items-center">
                <img class="leaf items-center" src="../../../../../src/assets/images/demo/alex-customize-leaf1.png" align="center"/>
              </div>
            </ul>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>
  </section>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>

  .con-vs-card {
    box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  }

  .mb-10rem {
    margin-bottom: 10rem;
  }

  .mb-5rem {
    margin-bottom: 5rem;
  }

  section {
    padding: 10rem 7rem 7rem 7rem;
  }

  .tips-heading {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #231D4F;
  }

  .tips-list li {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 20px 0px;
  }

  .leaf {
    width: 200px;
    text-align: center;
  }


  @media (max-width: 1200px) {
    section {
      padding: 10rem 0;
    }
  }
</style>
